(function () {
  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-pf-close-mobile]');
    if (!close) return;
    var details = document.querySelector('details.pf-mobile');
    if (details) details.removeAttribute('open');
  });

  function initPurchase() {
    var wrap = document.querySelector('[data-pf-purchase]');
    if (!wrap) return;
    var sellingPlanInput = wrap.querySelector('[data-pf-selling-plan]');
    var subLabel = wrap.querySelector('[data-pf-sub]');
    var priceEl = wrap.querySelector('[data-pf-price]');
    var radios = wrap.querySelectorAll('input[name="pf_purchase"]');

    function apply(val) {
      if (val === 'sub') {
        var planId = subLabel ? subLabel.getAttribute('data-selling-plan') : '';
        if (sellingPlanInput) sellingPlanInput.value = planId || '';
        if (priceEl) priceEl.textContent = '$48.00';
      } else {
        if (sellingPlanInput) sellingPlanInput.value = '';
        if (priceEl) priceEl.textContent = '$60.00';
      }
    }

    radios.forEach(function(r) {
      r.addEventListener('change', function() { apply(r.value); });
    });

    var hasPlan = subLabel && (subLabel.getAttribute('data-selling-plan') || '').trim().length > 0;
    var defaultVal = hasPlan ? 'sub' : 'one';
    var defRadio = wrap.querySelector('input[value="' + defaultVal + '"]');
    if (defRadio) defRadio.checked = true;
    apply(defaultVal);
  }

  document.addEventListener('DOMContentLoaded', initPurchase);
})();